import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  BillPayDetailMatchParams,
  billPayDetailRouteProps,
} from 'src/navigation/routeProps'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

export const selectVirtualCardIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<BillPayDetailMatchParams>(
      backgroundLocation.pathname,
      billPayDetailRouteProps,
    ) as match<BillPayDetailMatchParams>
    return mtch?.params.id
  },
)
